export default {
    namespaced: true,
    //状态
    state: {
        queryCondition: {},
    },
    //方法
    actions: {
    },
    mutations: {
        setSiteQueryCondition(state, payload) {
            state.queryCondition = payload;
        }
    }
}